module.exports = __webpack_public_path__ + "img/xq_pic.7dfdb64.png";